import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductGroupReferenceService extends BaseReferenceService {
  constructor() {
    super('ProductGroupReference');
  }
}
